import NextLink, { LinkProps as NextLinkProps } from 'next/link';
import { useTranslation } from 'react-i18next';

import { Link as ChakraLink, LinkProps as ChakraLinkProps, StyleProps } from '@chakra-ui/react';
import { ArrowLeftSmallIcon, ArrowRightSmallIcon } from '@udacity/chakra-uds-icons';

import { publicEnv } from '~/features/environment/public';

export type LinkProps = ChakraLinkProps &
  StyleProps &
  Omit<NextLinkProps, 'href'> & { withArrow?: boolean; isNative?: boolean };

export function Link(props: LinkProps) {
  const { i18n } = useTranslation();
  const languageDir = i18n.dir();

  const { withArrow, isNative, children, ...linkProps } = props;

  return (
    <ChakraLink
      as={isNative ? 'a' : NextLink}
      prefetch={publicEnv.NEXT_PUBLIC_ENVIRONMENT_NAME === 'test' ? false : null}
      {...linkProps}
    >
      {children} {withArrow && languageDir === 'ltr' && <ArrowRightSmallIcon h='32px' w='32px' />}
      {withArrow && languageDir === 'rtl' && <ArrowLeftSmallIcon h='32px' w='32px' />}
    </ChakraLink>
  );
}
